module.exports = __webpack_public_path__ + "img/geodir-natura-testimonial.6766c2f2.png";